import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, retry } from 'rxjs';
import { tagArray } from './tags.service';
import { UserService } from './user.service';

export interface IWorktask {
	id: string;
	alias: string;
	name: string;
	isActive: boolean;
	tags: tagArray;
}

export interface IWorktaskResponse {
	result: IWorktask;
}

export interface IWorktasks {
	result: IWorktask[];
}

interface IPostWorktaskRequest {
	alias: string;
	name: string;
	isActive: boolean;
	tags: tagArray;
}

@Injectable({
	providedIn: 'root',
})
export class WorktaskService {
	constructor(
		private http: HttpClient,
		private userService: UserService,
	) {}

	public static offWorkTaskId = '00000000-0000-0000-0000-000000000000';

	getWorktasks(): Observable<IWorktasks> {
		return this.http
			.get<IWorktasks>(`${environment.awsEnvUri}/mes/worktasks`, {
				headers: this.userService.getHeaders(),
			})
			.pipe(retry(1));
	}

	getWorktask(worktaskKey: string): Observable<IWorktaskResponse> {
		return this.http.get<IWorktaskResponse>(`${environment.awsEnvUri}/mes/worktasks/${worktaskKey}`, { headers: this.userService.getHeaders() });
	}

	getWorktaskByAlias(alias: string): Observable<IWorktaskResponse> {
		return this.http.get<IWorktaskResponse>(`${environment.awsEnvUri}/mes/worktasks/alias/${alias}`, { headers: this.userService.getHeaders() });
	}

	create(worktask: IWorktask): Observable<IWorktaskResponse> {
		const body: IPostWorktaskRequest = {
			alias: worktask.alias,
			name: worktask.name,
			tags: worktask.tags,
			isActive: worktask.isActive,
		};
		return this.http.post<IWorktaskResponse>(`${environment.awsEnvUri}/mes/worktasks`, body, {
			headers: this.userService.getHeaders(),
		});
	}

	update(worktask: IWorktask): Observable<any> {
		const body: IPostWorktaskRequest = {
			alias: worktask.alias,
			name: worktask.name,
			tags: worktask.tags,
			isActive: worktask.isActive,
		};
		return this.http.put(`${environment.awsEnvUri}/mes/worktasks/${worktask.id}`, body, {
			headers: this.userService.getHeaders(),
		});
	}
}
